import type {GData, SData} from "./components/Colorizer/types";
import {TheViewColorizeSchema} from "./types-analytics";
import type {TheViewColorizeType} from "./types-analytics";


export const convertTelematicsDataToTheViewColorize = (data: SData | GData): TheViewColorizeType => {

    const isSData = (data: SData | GData): data is SData => {
        return (data as SData).blocks !== undefined;
    }

    const isGData = (data: SData | GData): data is GData => {
        return (data as GData).groups !== undefined;
    }

    if (isSData(data)) {
        return convertSDataToTheViewColorize(data);
    } else if (isGData(data)) {
        return convertGDataToTheViewColorize(data);
    } else {
        throw new Error("Unknown data type");
    }
}

export const convertSDataToTheViewColorize = (data: SData): TheViewColorizeType => {
    const { blocks, use_filter, visible_min, visible_max, selected_option, related_options } = data;
    try {
        return TheViewColorizeSchema.parse({
            v: blocks.map( (block, index) => (index < blocks.length-1 ? block.max.toString() : "NaN") ),
            crit: {
                f: selected_option,
                p: related_options?.date_first || false,
                pref: (related_options?.compare_dates ? related_options?.date_second ?? false : false),
                r: related_options?.related_collection || null,
            },
            c: blocks.map(block => block.color.replace('#', '')),
            filter: use_filter,
            v_min: visible_min,
            v_max: visible_max,
            s: true, // FIXME: What is this? Allow to colorize? See: colorSet: function () ... this.colorize = { 'active': cfg.s };
            f: selected_option,
            f_out: selected_option,
            qc: blocks.length, // Not sure about this
            // related_options: related_options,
        })
    } catch (e) {
        console.debug('input: ', data);
        console.error(e);
        alert("Error while parsing output data in convertSDataToTheViewColorize");
        throw e;
    }
}

export const convertGDataToTheViewColorize = (data: GData): TheViewColorizeType => {
    const { groups, selected_option } = data;
    const elements: { v, c, name }[] = [];
    groups.forEach( (group, index) => {
        group.element_ids.forEach( element_id => {
            if (element_id === null) return;
            elements.push({
                v: element_id,
                c: group.color.replace('#', ''),
                name: group.name,
            })
        });
    });
    try {
        return TheViewColorizeSchema.parse({
            criteria_type: "dictionary",
            v: elements.map(element => element.v),
            crit: {
                f: selected_option,
                p: false  // FIXME: What is this?
            },
            c: elements.map(element => element.c.replace('#', '')),
            filter: 0, // FIXME: make true if needed
            s: true, // FIXME: What is this? Allow to colorize? See: colorSet: function () ... this.colorize = { 'active': cfg.s };
            allDictElements: 72, // Fixed value
            defaultObjectColor: "CCCCCC", // "Pozostałe" ?
            names: elements.map(element => element.name),
            // related_options: { // not used here, but required by schema
            //     date_first: null,
            //     date_second: null,
            //     compare_dates: false,
            // }
        });
    } catch (e) {
        console.debug('input: ', data);
        console.error(e);
        alert("Error while parsing output data in convertGDataToTheViewColorize");
    }
}
